import Fuse from 'fuse.js';
import { type TFunction } from 'i18next';
import { GoalIcon } from 'lucide-react';

import { type Campaign } from '@/shared/types/campaigns';

import { type EntityResult } from '../../types';
import { MAX_PER_TYPE } from '../../utils';

/**
 * Searches campaigns using a pre-built Fuse instance.
 * Returns up to MAX_PER_TYPE results sorted by fuzzy match score.
 */
export const searchCampaigns = (
  query: string,
  fuse: Fuse<Campaign> | null,
  t: TFunction
): EntityResult[] => {
  if (!fuse) {
    return [];
  }

  return fuse.search(query, { limit: MAX_PER_TYPE }).map(({ item: c, score }) => {
    const typePath = c.type === 'payment_recovery' ? 'payment-recovery' : 'outreach';
    return {
      id: c.campaign_id,
      name: c.name,
      type: 'campaign' as const,
      path: `/campaigns/${c.campaign_id}/${typePath}/setup`,
      icon: GoalIcon,
      subtitle:
        c.type === 'payment_recovery' ? t('campaigns.paymentRecovery') : t('campaigns.outreach'),
      score: 1 - (score ?? 0),
    };
  });
};
